import React, { useContext, useEffect, useState } from 'react';
import { ConfigContext } from 'src/components/AppShell/ConfigProvider';
import { GoogleTagManager } from 'src/components/Scripts/GoogleTagManager';
import { useKlaviyoIdentify } from 'src/features/klaviyo/hooks/useKlaviyoIdentify';

import { LiveChat } from './LiveChat';
import { Klaviyo, initKlaviyoQueue } from './Klaviyo';
import { Leadfeeder } from './Leadfeeder';
import { scheduleIdle } from './scheduleIdle';

export const Scripts: React.FC = () => {
    const context = useContext(ConfigContext);
    const isLiveChat = context.liveChat.enabled;
    const isGtm = context.gtm.enabled;
    const isKlaviyo = context.klaviyo.enabled;
    const isLeadfeeder = context.leadfeeder.enabled;
    const [ready, setReady] = useState(false);

    // Initialize Klaviyo queue early so tracking can queue events before script loads
    useEffect(() => {
        if (isKlaviyo) {
            initKlaviyoQueue();
        }
    }, [isKlaviyo]);

    // Identify logged-in users in Klaviyo (handles both fresh login and restored sessions)
    useKlaviyoIdentify();

    // Defer marketing SDKs until idle (or 3s) so they don't compete with first paint.
    useEffect(() => scheduleIdle(() => setReady(true), 3000), []);

    return (
        <div>
            {ready && isLiveChat && <LiveChat enabled={context.liveChat.enabled} apiKey={context.liveChat.apiKey} />}
            {isGtm && <GoogleTagManager enabled={context.gtm.enabled} id={context.gtm.id} />}
            {ready && isKlaviyo && <Klaviyo enabled={context.klaviyo.enabled} companyId={context.klaviyo.companyId} />}
            {ready && isLeadfeeder && <Leadfeeder enabled={context.leadfeeder.enabled} />}
        </div>
    );
};
